import React from 'react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  return <section className="py-8 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-brand-dark to-pink-50/30" data-id="element-274">
      <div className="max-w-4xl mx-auto text-center" data-id="element-275">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg text-gray-500 font-medium mb-4" data-id="element-276">
          Por eso creamos:
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-pink-100 border border-pink-200 text-brand-accent px-6 py-2 rounded-full mb-6" data-id="element-277">
          <span className="text-xl" data-id="element-278">🏆</span>
          <span className="font-bold tracking-wide text-sm md:text-base" data-id="element-279">
            SISTEMA FITNESS PARA MAMÁS – MÉTODO 90D
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="font-display text-2xl md:text-4xl font-black mb-4 text-gray-900 leading-tight" data-id="element-280">
          Un sistema diseñado específicamente para mujeres reales…
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl md:text-2xl text-brand-accent font-bold flex items-center justify-center gap-2" data-id="element-281">
          👉 con hijos, responsabilidades y poco tiempo
        </motion.p>
      </div>
    </section>;
}